<script setup>
import { reactive } from 'vue';
import { Form } from 'vee-validate';
import FormInputCheckbox from '../fields/FormInputCheckbox.vue';
import * as yup from 'yup';
import { checkboxValidation } from '../utils/validations';

const emit = defineEmits(['advance-step']);

const props = defineProps({
    formData: {
        type: Object,
        required: true
    },
    insurer: {
        type: Object,
        required: true
    }
});

// Hydrate data when changing steps
const fields = reactive({
    acceptPolicyAuthority: false,
    ...props.formData
});

const submit = (values) => {
    console.log(values);
    emit('advance-step', values);
};

const schema = yup.object({
    acceptPolicyAuthority: checkboxValidation
});
</script>
<template>
    <Form :validation-schema="schema" @submit="submit">
        <h2 class="h2 panel-heading">Policy Authority</h2>
        <div class="form-panel wysiwyg-output">
            <p>
                I/we declare that I/we have read the following statements and I/we agree and
                acknowledge that:
            </p>

            <ul>
                <li>
                    In the event that {{ props.insurer.name }} determines to not accept my/our
                    application on standard terms
                    <ul>
                        <li>
                            I/we authorise {{ props.insurer.name }} to inform my/our financial
                            adviser (if applicable), or other representative, of the reasons for
                            that decision, and
                        </li>
                        <li>
                            I/we understand that {{ props.insurer.name }} will not provide copies of
                            medical or other reports to my/our financial adviser (if applicable), or
                            other representative, without first obtaining my/our consent; and
                        </li>
                        <li>
                            I/we authorise my/our financial adviser (if applicable), or other
                            representative, to communicate to {{ props.insurer.name }} my/our
                            acceptance of any alternative terms on my/our behalf
                        </li>
                    </ul>
                </li>
                <li>
                    I/we have authorised {{ props.insurer.name }} to debit my/our premiums if credit
                    card or bank account details are provided with my/our application.
                </li>
                <li>
                    I/we authorise {{ props.insurer.name }} to communicate with any Authorised
                    Representative(s) (representatives who the Policy Owner has authorised to
                    provide information to {{ props.insurer.name }} under a Third Party Authority
                    Form) about information relating to my insurance policies, including any
                    information which contains my personal medical information, financial
                    information, claims, servicing and policy administration issues and/or
                    complaints.
                </li>
            </ul>

            <FormInputCheckbox
                class="tw-mt-6 sm:tw-mt-10"
                name="acceptPolicyAuthority"
                :value="fields.acceptPolicyAuthority"
                label="I, the Life Insured confirm I have read and acknowledge the above Policy Authority.*"
            />
        </div>

        <button class="btn btn--green btn--full">Next</button>
    </Form>
</template>
